module.exports = __webpack_public_path__ + "media/src/images/background-11e4ebd1a059c00a6bf51ba21fe361bf.png";